module.exports = __webpack_public_path__ + "static/media/logo.b733c93d.png";